import PropTypes from 'prop-types';

const propType = {
  termsLink: PropTypes.string,
  privacyLink: PropTypes.string,
};

export default { propType };
